sharpen-story-header {
  display: block;
  text-align: center;
  margin: 0 0 var(--spacing-lg) 0;

  img { height: 12rem; }
  .sharpen-icon { font-size: 64pt; color: var(--color-red); }
}